import { DynamicViewComponentExtranet1 } from '../../../tickets_common'
import { isLastStep } from '../utils'

const ViewWrapper = (props) => {
  const { record } = props
  if (isLastStep(record) === true) {
    return null
  }
  return <DynamicViewComponentExtranet1 {...props} record={record} />
}
export default ViewWrapper
